<template>
    <p-modal
        class="idle-time-alert-modal"
        name="idle-time-alert-modal"
        :width="517"
        :height="400"
    >
        <div class="quantity-exceed-modal">
            <div class="modal-header">
                <div class="d-flex">
                    <div class="alert-img">
                        <img
                            src="/img/icons/alert-icon.svg"
                            alt=""
                            class="btn-icon"
                        >
                    </div>
                    <div class="header-content">
                        <span>You have been <span class="text-red"> inactive </span> for <b> 10 MINUTES </b>. You will be logout in <b> 5 MINUTES </b> if no action is taken</span>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="modal-footer">
                    <p-button style="padding: 9px 13px;min-width:140px"
                              @click="$emit('closeModal')"
                    >
                        OK
                    </p-button>
                </div>
            </div>
        </div>

    </p-modal>

</template>

<script>
import PModal from '~/components/core/PModal'
import PButton from '~/components/core/PButton'
import componentHelpers from '~/mixins/componentHelpers'
import { mapActions, mapMutations } from 'vuex'

export default {
    name: 'IdleTimeAlert',
    components: { PModal, PButton },
    mixins: [componentHelpers],
    data() {
        return {
            showModal: false,
            idleTime: 0,
            timer: null,
            remainingTime: 300, // 5 minutes countdown after 10 mins
        };
    },
    mounted() {
        this.startTimer();
        this.addEventListeners();
    },
    beforeDestroy() {
        this.removeEventListeners();
        clearInterval(this.timer);
    },
    methods: {
        ...mapMutations({
            clearActiveCollection: 'catalog_products/CLEAR_ACTIVE_COLLECTION'
        }),
        ...mapActions({
            logout: 'auth/logout',
            clearActiveDraftOrder: 'orders/clearActiveDraftOrder',
        }),
        startTimer() {
            this.timer = setInterval(() => {
                this.idleTime++;
                if (this.idleTime === 600) { // 10 minutes
                    this.$emit('showModal')
                    this.startCountdown();
                }
                if (this.idleTime >= 900) { // 15 minutes
                    this.logoutUser();
                }
            }, 1000);
        },
        resetTimer() {
            this.idleTime = 0;
            this.$emit('closeModal')// Hide modal only if it's already shown
            this.remainingTime = 300;
        },
        startCountdown() {
            const countdownInterval = setInterval(() => {
                this.remainingTime--;
                if (this.remainingTime <= 0 || !this.showModal) {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        },
        logoutUser() {
            this.clearActiveCollection()
            this.clearActiveDraftOrder()
            this.logout()
            setTimeout(() => {
                this.$router.push({name: 'login'})
            }, 1000)
        },
        addEventListeners() {
            window.addEventListener('mousemove', this.resetTimer);
            window.addEventListener('mousedown', this.resetTimer);
            window.addEventListener('keypress', this.resetTimer);
            window.addEventListener('touchstart', this.resetTimer);
            window.addEventListener('click', this.resetTimer);
        },
        removeEventListeners() {
            window.removeEventListener('mousemove', this.resetTimer);
            window.removeEventListener('mousedown', this.resetTimer);
            window.removeEventListener('keypress', this.resetTimer);
            window.removeEventListener('touchstart', this.resetTimer);
            window.removeEventListener('click', this.resetTimer);
        },
    },
};
</script>

<style lang="scss" scoped>
.idle-time-alert-modal {
    ::v-deep {
        .vm--modal {
            max-width: 517px !important;
        }
    }
    .text-red {
        color: #FF0000;
        font-weight: bold !important;
        text-transform: uppercase;
    }
    .quantity-exceed-modal {
        .modal-header {
            padding: 22px 24px;
            position: relative;
            padding-bottom: 19px;
            padding-top: 41.2px;
            .alert-img {
                margin-left: auto;
                margin-right: 0px;
                img {
                    width: 49.2px;
                    height: 45.68px;
                }
            }
            .header-content {
                padding-left: 7.5px
            }

            span {
                text-align: left;
                font: normal normal normal 16px/18px Arial;
                letter-spacing: 0px;
            }
        }
        .modal-footer {
            justify-content: center;
            gap: 15px;
            margin-bottom: 30px;
        }
    }
}
</style>

<style>
.idle-time-alert-modal {
    .vm--overlay {
        background: rgba(0, 0, 0, 0.7) !important;
    }
}
</style>
